import Vue from 'vue'
import axios from 'axios'

const state = {
  isAdding: false,
  isAbleToReview: false,
  positiveTopics: null,
  negativeTopics: null,
  selectedPositiveTopics: null,
  selectedNegativeTopics: null,
  reviewByUsers: [],
  reviewedRating: null
}

const actions = {
  LOAD_REVIEW_BY_USER: async ({ commit }) => {
    commit('SET_REVIEWS_BY_USER', [])
    let { data } = await axios.get('get-reviews-from-user')
    if (!data.error) {
      commit('SET_REVIEWS_BY_USER', data.professional_reviews)
    }
  },
  ADD_REVIEW: async ({ commit }, submitData) => {
    commit('SET_REVIEWED_RATING', null)
    const url = 'evaluates'
    const res = await axios.post(url, submitData)
    if (res.status === 200) {
      commit('SET_REVIEWED_RATING', submitData.rating)
      const response = res.data
      if (!response.error) {
        console.log(response)
      }
    }
  },
  LOAD_RATING_TOPICS: ({ commit }) => {
    const url = 'evaluates/topics'
    Vue.http.get(url)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_RATING_TOPICS', response)
        }
      })
  }
}

const mutations = {
  SET_REVIEWS_BY_USER: (state, data) => {
    if (data.length === 0) {
      state.reviewByUsers = []
    } else {
      state.reviewByUsers.push(...data)
    }
  },
  SET_IS_ABLE_TO_REVIEW: (state, status) => {
    state.isAbleToReview = status
  },
  SET_RATING_TOPICS: (state, data) => {
    state.positiveTopics = data.positive_topics
    state.negativeTopics = data.negative_topics
  },
  SET_SELECTED_RATING_TOPICS: (state, topic) => {
    if (topic) {
      if (topic.topic_type === 'positive') {
        if (state.selectedPositiveTopics === null) {
          state.selectedPositiveTopics = []
        }
        if (state.selectedPositiveTopics.includes(topic.id)) {
          const index = state.selectedPositiveTopics.indexOf(topic.id)
          if (index !== -1) {
            state.selectedPositiveTopics.splice(index, 1)
            if (state.selectedPositiveTopics.length === 0) {
              state.selectedPositiveTopics = null
            }
          }
        } else {
          state.selectedPositiveTopics.push(topic.id)
        }
      } else {
        if (topic) {
          if (state.selectedNegativeTopics === null) {
            state.selectedNegativeTopics = []
          }
          if (state.selectedNegativeTopics.includes(topic.id)) {
            const index = state.selectedNegativeTopics.indexOf(topic.id)
            if (index !== -1) {
              state.selectedNegativeTopics.splice(index, 1)
              if (state.selectedNegativeTopics.length === 0) {
                state.selectedNegativeTopics = null
              }
            }
          } else {
            state.selectedNegativeTopics.push(topic.id)
          }
        } else {
          state.selectedNegativeTopics = null
        }
      }
    } else {
      state.selectedPositiveTopics = null
      state.selectedNegativeTopics = null
    }
  },
  SET_REVIEWED_RATING: (state, rating) => {
    state.reviewedRating = rating
  }
}

const getters = {
  getState: state => {
    return state
  },
  isAbleToReview: state => {
    return state.isAbleToReview
  },
  isAdding: state => {
    return state.isAdding
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/review.js